<template>
  <div class="cbg-white-container input-container theme--light v-card p-16 border-card">
    <div class="col-sm-12 row ml-0 pl-0 pr-0">
      <!-- <div class="form-group col-sm-6 col-md-3 pl-0 pr-0 position-relative">
        <label for>Filter</label>
        <div class="search-div position-relative">
          <input
            type="text"
            @keyup="getChats(1)"
            placeholder="Search"
            v-model="user_full_name"
            class="form-control"
          />
          <div
            v-if="user_full_name !== ''"
            class="search-svg position-absolute"
            @click="clearSearch()"
          >
            <crossSVG />
          </div>
        </div>
      </div> -->
      <v-col cols="12" md="3">
        <div class="position-relative">
          <label for>Filter by role</label>
          <select name id class="form-control" @change="getSelectedRole()" v-model="status">
            <option v-for="(option, i) in statusOptions" :key="i" :value="option.value">
              {{ option.name }}
            </option>
          </select>
          <span class="drop-icon">
            <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
          </span>
        </div>
      </v-col>
      <!-- <div class="form-group col-sm-3">
        <label for>Status</label>
      </div>-->
    </div>
    <div class="table-div">
      <table class="table tds userlistTable">
        <thead>
          <tr>
            <th>Full Name</th>
            <th v-if="permissions.includes('CAN_CREATE_CHAT')">Actions</th>
          </tr>
        </thead>
        <tbody v-for="(chat, index) in chats" :key="index">
          <tr>
            <td class="text-capitalize">{{ chat.user.full_name }} <small class="role-tag">{{ chat.receiver_role }}</small>
            </td>
            <td v-if="permissions.includes('CAN_CREATE_CHAT')">
              <v-btn class="btn btn-primary" @click="goToChat(chat)">View</v-btn>
            </td>
          </tr>
        </tbody>
      </table>
      <pagination class="pagination-block" :recordPerPage="10" :currentPage="current_page" :total="total"
        @changePage="changePage" />
    </div>
  </div>
</template>

<style>
.role-tag {
  margin-left: 8px;
  font-size: 10px;

}
</style>

<script>
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  components: {
    pagination: () => import("@/views/common/Pagination"),
    ...pickSvg("crossSVG")
  },
  data() {
    return {
      chats: [],
      user_full_name: "",
      total_page: 1,
      current_page: 1,
      total: 0,
      statusOptions: [],
      status: "patient"
    }
  },
  mounted() {
    this.getAllRoles()
    // this.getChats(1);
  },
  methods: {
    clearSearch() {
      this.user_full_name = "";
    },
    changePage(page) {
      this.getChats(page.currentPage);
    },
    goToChat(chat) {
      this.$router.push({
        name: "chat",
        params: { chatId: chat._id, user_name: chat.user.full_name }
      });
    },
    getChats(page) {
      let params = { page, receiver_role: this.status };
      if (this.user_full_name) {
        params.user_full_name = this.user_full_name;
      }
      this.$http
        .get(`${config.BASE_URL}api/v2/admin/system-chats`, { params })
        .then(response => {
          if (response.body.status) {
            this.chats = response.body.data.list;
            this.total_page = response.body.data.total;
            this.current_page = response.body.data.page;
            this.total = response.body.data.count;
          }
        });
    },
    getAllRoles(){
      this.$http
        .get(`${config.BASE_URL}api/v2/active-roles`,)
        .then(response => {
          if (response.body.status) {
            response.body.data.forEach(data=>{
              this.statusOptions.push({
                name:data.role.toUpperCase(),
                value:data.role
              })
            })
            this.statusOptions.push({
              name:"ALL",
              value:"all"
            })
            this.getChats(1);
          }
        });
    },
    getSelectedRole() {
      this.getChats(1);
    }
  }
};
</script>
